import React, { createContext, useContext, useEffect, useState } from 'react';
import defaultContent from './defaultContent';

const ContentContext = createContext(defaultContent);

// 深合并：对象递归合并，数组与基本类型直接覆盖（用后端值）
export function deepMerge(base, override) {
  if (Array.isArray(override)) return override;
  if (override && typeof override === 'object' && !Array.isArray(override)) {
    const out = { ...base };
    for (const k of Object.keys(override)) {
      out[k] = k in base ? deepMerge(base[k], override[k]) : override[k];
    }
    return out;
  }
  return override === undefined ? base : override;
}

export function ContentProvider({ children }) {
  const [content, setContent] = useState(defaultContent);

  useEffect(() => {
    let alive = true;
    fetch('/api/content', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((data) => {
        if (alive && data && typeof data === 'object') {
          setContent(deepMerge(defaultContent, data));
        }
      })
      .catch(() => {}); // 用默认内容兜底
    return () => { alive = false; };
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export function useContent() {
  return useContext(ContentContext);
}